// extracted by mini-css-extract-plugin
module.exports = {"downloadInstructions":"downloadInstructions-module--downloadInstructions--2U77B","downloadInstructions__entry":"downloadInstructions-module--downloadInstructions__entry--3R8x0"};